<template>
  <section>
    <div class="hero ">
      <div class="hero-body background-light">
        <div class="container">
          <h1 class="title is-size-1-desktop is-size-2-mobile has-text-centered">Admin</h1>
        </div>
      </div>
    </div>

    <div class="hero is-small background-primary">
      <div class="hero-body">
      </div>
    </div>

    <div class="hero">
      <div class="hero-body background-light">
        <div class="container">
          <div>
            <h2 class="title is-size-2-desktop is-size-3-mobile has-text-centered">RSVPs</h2>
            <b-table
                    :data="data"
                    :loading="isLoading"
                    :mobile-cards="true"
                    default-sort="created"
                    default-sort-direction="desc"
                    detailed
                    detail-key="id">

              <template slot-scope="props">
                <b-table-column field="name" label="Name" sortable>
                  {{ props.row.name }}
                </b-table-column>

                <b-table-column field="created" label="Created" sortable>
                  {{ props.row.createdString }}
                </b-table-column>

                <b-table-column field="phone" label="Phone" sortable>
                  <a :href="'tel:' + props.row.phone">{{ props.row.phone }}</a>
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                  <a :href="'mailto:' + props.row.email" target="_blank">{{ props.row.email }}</a>
                </b-table-column>

                <b-table-column field="attending" label="Attending" centered>
                    <span class="tag" :class="props.row.attending ? 'is-success' : 'is-danger'">
                        {{ props.row.attending ? 'Yes': 'No' }}
                    </span>
                </b-table-column>

                <b-table-column field="plusOne" label="Plus one" centered>
                    <span class="tag" :class="props.row.plusOne ? 'is-success' : 'is-danger'">
                        {{ props.row.plusOne ? 'Yes': 'No' }}
                    </span>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                              icon="far fa-frown"
                              size="is-large">
                      </b-icon>
                    </p>
                    <p>Nothing here.</p>
                  </div>
                </section>
              </template>

              <template slot="detail" slot-scope="props">
                <div class="content">
                  <p>
                    <strong>Message</strong>
                  </p>
                  <p>
                    {{ props.row.message }}
                  </p>
                </div>
              </template>
            </b-table>
      </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import firebase from 'firebase/app'
import store from '../store'

export default {
  name: 'Admin',
  data () {
    return {
      user: null,
      isLoading: false,
      data: []
    }
  },
  mounted () {
    this.user = store.state.user

    const db = firebase.firestore()

    // Disable deprecated features
    db.settings({
      timestampsInSnapshots: true
    })

    this.isLoading = true
    db.collection('rsvp').get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.data.push({
          id: doc.id,
          name: doc.data().name,
          attending: doc.data().attending,
          plusOne: doc.data().plusOne,
          created: doc.data().created,
          createdString: doc.data().created.toDate().toLocaleDateString(),
          phone: doc.data().countryCode + doc.data().phone,
          email: doc.data().email,
          message: doc.data().message
        })
      })
      this.isLoading = false
    }).catch(error => {
      console.log('Error:', error)
      if (error.code === 'permission-denied') {
        this.$toast.open({
          duration: 5000,
          message: `Permission denied. Talk to John.`,
          position: 'is-bottom',
          type: 'is-danger'
        })
      } else {
        this.$toast.open({
          message: `Something went wrong. Talk to John.`,
          position: 'is-bottom',
          type: 'is-danger'
        })
      }
      this.isLoading = false
    })
  }
}
</script>

<style scoped lang="scss">

</style>
